import { useGoogleLogin as useGoogleLogin2 } from "@react-oauth/google";
import { useEffect, useState } from "react";
import useLoginPromotion from "./useLoginPromotion";

/**
 * 프로모션 퍼널 Google 로그인. 팝업 인가 코드를 서버(/user/v2/login)로 보내고 서버가
 * client_secret 으로 교환한다 (예전엔 브라우저가 직접 교환해 시크릿이 번들에 들어 있었다).
 */
export default function useGoogleLoginV2(referralCode?: string) {
  const origin = window.location.origin;

  const [code, setCode] = useState<string>();

  const { login, isLoading, error } = useLoginPromotion({
    url: `/user/v2/login`,
    code,
    redirectUri: origin,
    type: "google",
    referralCode: referralCode,
  });

  useEffect(() => {
    if (code) {
      login().catch(() => {
        setCode(undefined);
      });
    }
  }, [code]);

  const handleGoogleLogin = useGoogleLogin2({
    onSuccess: (codeResponse) => setCode(codeResponse.code),
    flow: "auth-code",
    ux_mode: "popup",
    redirect_uri: origin,
    // 이름·프로필 사진은 쓰지 않는다. 라이브러리 기본값("openid profile email")에서 profile 을 뺀다.
    scope: "openid email",
    overrideScope: true,
  });

  return { handleGoogleLogin, isLoading, error };
}
